import React from 'react';
import PropTypes from 'prop-types';
import verifyLoginCallback from './verifyLoginCallback';

class AuthCallback extends React.Component {
    static propTypes = {
        location: PropTypes.shape({
            query: PropTypes.object,
        }).isRequired,
    };

    componentDidMount() {
        const { location } = this.props;
        verifyLoginCallback({ location })
            .then(({ origin }) => window.location.assign(origin))
            .catch((err) => {
                console.error(err); // eslint-disable-line no-console
                // redirect to frontpage if invalid state
                window.location.assign('/');
            });
    }

    render() {
        return <h4 style={{ textAlign: 'center', margin: '60px' }}>Vennligst vent.</h4>;
    }
}

export default AuthCallback;



/** WEBPACK FOOTER **
 ** ./src/screens/auth-callback/index.js
 **/